import DOMPurify from 'dompurify';

export const stripHtml = (html: string | undefined): string => {
  if (!html) return '';
  const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
  return clean;
};

export const sanitizeBodyForSave = (text: string): string => {
  const esc = (s: string) =>
    s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  return esc(text).replace(/\n/g, '<br>');
};

export const sanitizeTitleForSave = (title: string): string => {
  return title.trim();
};
